import { render, staticRenderFns } from "./CorpSnapshot.vue?vue&type=template&id=ab8e7062"
import script from "./CorpSnapshot.vue?vue&type=script&lang=ts"
export * from "./CorpSnapshot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports